import { IconButton, Menu, Skeleton, TableCell, TableRow } from "@mui/material";
import { KeyDriveBodyMin } from "../../Fonts/Body/KeyDriveBodyMin";
import { KeyDriveAvatar } from "../../Avatar/KeyDriveAvatar";
import GroupIcon from '@mui/icons-material/Group';
import { Delete, Edit, Group, VerticalAlignBottom } from "@mui/icons-material";
import { UserPermission } from "../../../../model/UserModel";
import { KeyDriveChip } from "../../Tags/KeyDriveChip";
import KeydriveMenu, { IKeydriveMenuTable } from "../../KeydriveMenu/KeydriveMenu";
import { StatePrivilegesTypes } from "../../../../pages/WorkSpace/Permissions/WorkSpacePermissions";
import { GroupPermission } from "../../../../model/GroupModel";
import usePrivilegeName from "../../../../functions/hooks/usePrivilegeName";

interface IGroupRowDefault {
    loading: boolean;
    group: GroupPermission;
    setPrivilegesState?: (set: { state: StatePrivilegesTypes, id: string, permissionType: number }) => void;
}

function GroupRowDefault({
    loading,
    group,
    setPrivilegesState
}: IGroupRowDefault) {

    const { privilegeName } = usePrivilegeName(group?.permissionType!);

    return (
        <TableRow style={{ display: 'table-row', border: "1px solid rgba(224, 224, 224, 1)" }}>
            {
                <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0, border: "none" }}>

                    {(!loading) ?
                        <IconButton
                            onClick={() => {}}
                        >
                            <KeydriveMenu<IKeydriveMenuTable> 
                                options={[
                                    {
                                        icon: <Edit />,
                                        onClick: () => {
                                            setPrivilegesState!({ state: "editing group", id: group.groupId!, permissionType: group.permissionType });
                                        },
                                        text: "Editar"
                                    },
                                    {
                                        icon: <Delete />,
                                        onClick: () => {
                                            setPrivilegesState!({ state: "deleting permission", id: group.groupId!, permissionType: group.permissionType });
                                        },
                                        text: "Deletar"
                                    },
                                ]}
                            />
                        </IconButton> :
                        <Skeleton animation="wave" variant="circular" width={24} height={24} />
                    }
                </TableCell>
            }
            <TableCell sx={{ display: 'flex', alignItems: "center", gap: 1, paddingX: '8px', paddingY: "18px", border: "none" }}>
                {(!loading) ?
                    <Group /> :
                    <Skeleton animation="wave" variant="circular" width={26} height={26} />
                }

                {(!loading) ?
                    <KeyDriveBodyMin
                        color="#2D2D2D"
                        needBold
                        needEllipses={false}
                        text={group?.groupName}
                    /> :
                    <Skeleton width='100%' />
                }
            </TableCell>
            <TableCell sx={{ paddingX: '8px', paddingY: "20px", border: "none" }}>
                {(!loading) ?
                    <KeyDriveBodyMin
                        color="#2D2D2D"
                        needBold
                        needEllipses={false}
                        text={group?.users?.length! > 0 ? group?.users?.length.toString()! : "Nenhum participante" }
                    /> :
                    <Skeleton />
                }
            </TableCell>
            {
                <TableCell key={group?.groupId} sx={{ paddingX: '8px', paddingY: "16px", display: "flex", justifyContent: "center", border: "none" }}>
                    {(!loading) ?
                        <KeyDriveChip 
                            text={privilegeName}
                        />
                        : 
                        <Skeleton />
                    }
                </TableCell>
            }
        </TableRow>
    )
}

export default GroupRowDefault;